// extracted by mini-css-extract-plugin
export default {"tabs":"animatedTabs_tabs__O33dS","tab":"animatedTabs_tab__ZSnp6"};